export default function AquariumLogo({
    icon = "#ffffff",
    bg = "#0ABAB5",
    size = 100,
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 370 370"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="370" height="370" fill={bg} />
            <path d="M106.007 187.555C159.014 90.2467 276.512 94.45 319 135.272C318.98 135.465 312.688 196.574 234.56 230.326C176.901 255.166 120.791 229.004 120.791 229.004C112.815 240.812 109.625 264.795 72.208 281.864L85.4023 218.218C78.7444 212.8 59.3428 196.998 35 177.135C71.2568 167.947 87.1002 179.523 106.007 187.555ZM241.971 124.497C231.687 124.497 223.35 132.834 223.35 143.117C223.35 153.401 231.687 161.738 241.971 161.738C252.255 161.738 260.591 153.401 260.591 143.117C260.591 132.834 252.254 124.497 241.971 124.497Z" fill={icon} />
        </svg>

    )
}
